// extracted by mini-css-extract-plugin
module.exports = {"loading":"VipConsultation_loading__W1AoW"};